<app-case-form-section-container [iconClass]="'bi bi-newspaper'" [title]="'label.news'">
    <div *ngIf="news.length > 0" class="news-list">
      <div class="col-12">
        <div *ngFor="let newsItem of news" class="news-item-container mb-3">
          <app-news-preview [newsItem]="newsItem" [showMenu]="false" (click)="onViewNews(newsItem)">
          </app-news-preview>
        </div>
      </div>
    </div>
  
    <app-pagination 
      *ngIf="news.length > 0 && totalNewsCount > selectedPageSize" 
      [currentPage]="currentPage"
      [totalItems]="totalNewsCount"
      [itemsPerPage]="selectedPageSize"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="onPageSelect($event)"
      (itemsPerPageChange)="onItemsPerPageChange($event)">
    </app-pagination>
</app-case-form-section-container>
  